import React, { useEffect } from "react";
import Header from "../Component/Header";
import Footer from "../Component/Footer";
import { Link } from "react-router-dom";
function ContactUs() {
  useEffect(() => {
    document.title = "Contact Us-  CARMEL CONVENT SCHOOL, DHARUHERA";
  }, []);
  return (
    <>
      <Header />
      <div className="sliderbg"></div>
      <div className="innerpage">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <ul className="breadcrumbli">
                <li>
                  <Link to="/"> Home </Link>
                </li>
                <li>Contact Us</li>
              </ul>
            </div>
            <div className="col-lg-12">
              <h2 className="innerheading">Contact Us</h2>
            </div>
          </div>
          <div className="enquiryform">
            <div className="enquiryformimg">
              <div className="locationbox">
                <div className="locationdiv">
                  <div className="locationicon">
                    <i className="bi bi-geo-alt"></i>
                  </div>
                  <div className="locationdetails">
                    <h5>address</h5>
                    <p>
                      <Link
                        to="https://www.google.com/maps?q=28.1692234,76.7862046"
                        target="_blank"
                        rel="noopener noreferrer">
                        Village Alawalpur near Jyoti Hotel,Nandrampur Bass,
                        Nandrampur Bass Road,Teh. Dharuhera, District
                        Rewari, Haryana 12310
                      </Link>
                    </p>
                  </div>
                </div>
                <div className="locationdiv">
                  <div className="locationicon">
                    <i className="bi bi-telephone"></i>
                  </div>
                  <div className="locationdetails">
                    <h5>Phone</h5>
                    <p>
                      <Link to="tel:+918168540345"> +91 8168540345 </Link>
                    </p>
                  </div>
                </div>
                <div className="locationdiv">
                  <div className="locationicon">
                    <i className="bi bi-envelope"></i>
                  </div>
                  <div className="locationdetails">
                    <h5>Email</h5>
                    <p>
                      <Link to="mailto:carmelschooldharuhera@gmail.com">
                        {" "}
                        carmelschooldharuhera@gmail.com{" "}
                      </Link>
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="contactdiv">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3516.811901805506!2d76.78779887609798!3d28.182635404367684!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390d49807f4d9775%3A0x66293a53bee4797d!2sCarmel%20Convent%20School!5e0!3m2!1sen!2sin!4v1741174239580!5m2!1sen!2sin"
                width="100%"
                height="470"
                loading="lazy"
                title="Google Maps"
                style={{ border: "0px" }}></iframe>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default ContactUs;
